import productsPlansDevelopment from '../products-plans-development.json'
import productsPlansStaging from '../products-plans-staging.json'
import productsPlansProduction from '../products-plans-production.json'

function getProductsPlansData() {
  const config = process.env.REACT_APP_CONFIG
  if (config === 'Debug') return productsPlansDevelopment
  if (config === 'Staging') return productsPlansStaging
  return productsPlansProduction
}

export function getAppPremiumProducts() {
  const { products, plans } = getProductsPlansData()

  const appPremiumProducts = products.filter(
    product => product.active && product.metadata?.planType === 'appPremium'
  )

  const productsWithPrices = appPremiumProducts.map(product => {
    const prices = plans.filter(
      plan => plan.active && plan.product === product.id
    )
    return { ...product, prices }
  })

  return Promise.resolve({ products: productsWithPrices })
}
